<template>
  <!-- Financial Close Sidebar (extracted) -->
  <v-list
    data-testid="financial-close-menu"
    class="overflow-scroll d-flex flex-column align-start justify-space-between all-width sidenav-list pa-0"
    style="overflow-y: scroll; height:100%"
  >
    <v-list data-testid="financial-close-menu__main-list" class="pa-0 all-width menu-list d-flex flex-column gap-1">
      <template v-for="item in displayMenu">
        <!-- 1. Simple leaf item -->
        <v-list-item
          data-testid="financial-close-menu__leaf-item"
          v-if="!item.items"
          :key="item.name + '-leaf'"
          :to="$nova.gotoLink({ path: item.href, hash: item.hash }, true)"
          link
          @click="handleTopLevelClick(item)"
          class="d-flex align-center justify-start all-width side-nav-text-color nav-standard-item"
          :class="selectedItem === item.name ? ' radius-small selected-menu-item' : ''"
        >
          <v-tooltip data-testid="financial-close-menu__leaf-tooltip" v-if="mini" right content-class="tooltip-right">
            <template #activator="{ on, attrs }">
              <span data-testid="financial-close-menu__leaf-icon-wrapper" v-bind="attrs" v-on="on" class="d-flex align-center">
                <span data-testid="financial-close-menu__leaf-mdi-icon" v-if="isMdi(item.icon)"><v-icon class="pr-2">{{ item.icon }}</v-icon></span>
                <span data-testid="financial-close-menu__leaf-img-icon" class="pr-2 d-flex" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
                <span data-testid="financial-close-menu__leaf-default-icon" class="pr-2" v-else><v-icon>mdi-folder-outline</v-icon></span>
              </span>
            </template>
            <span data-testid="financial-close-menu__leaf-tooltip-text" class="">{{ item.name }}</span>
          </v-tooltip>
          <template v-else>
            <span data-testid="financial-close-menu__leaf-mdi-icon" v-if="isMdi(item.icon)"><v-icon class="pr-2">{{ item.icon }}</v-icon></span>
            <span data-testid="financial-close-menu__leaf-img-icon" class="pr-2 d-flex" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
            <span data-testid="financial-close-menu__leaf-default-icon" class="pr-2" v-else><v-icon>mdi-folder-outline</v-icon></span>
          </template>
          <v-list-item-content data-testid="financial-close-menu__leaf-content" class="pa-0 d-flex align-center justify-start flex-grow-1">
            <v-list-item-title
              data-testid="financial-close-menu__leaf-title"
              class="side-nav-text-color hide-when-mini"
            >{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- 2. FC Masters fly-out -->
        <v-menu
          data-testid="financial-close-menu__fc-masters-menu"
          v-else-if="item.name === FC_MENU_NAMES.MASTERS"
          :key="item.name + '-fcmasters'"
          v-model="fcMastersMenu"
          :disabled="!canAccessFinancialCloseMasters"
          offset-x
          :nudge-right="0"
          :close-on-content-click="false"
          :open-delay="hoverOpenDelay"
          :close-delay="hoverCloseDelay"
          transition="fade-transition"
          :content-class="'fcmasters-menu ' + menuContentClass"
          @input="onFcMastersMenuInput"
          open-on-hover
        >
          <template #activator="{ on, attrs }">
            <v-list-item
              data-testid="financial-close-menu__fc-masters-activator"
              v-bind="attrs"
              v-on="canAccessFinancialCloseMasters ? on : {}"
              :disabled="!canAccessFinancialCloseMasters"
              class="d-flex align-center justify-start all-width side-nav-text-color nav-standard-item"
              :class="(fcMastersMenu || isHeaderActive(item)) ? ' radius-small selected-menu-item' : ''"
            >
              <v-tooltip data-testid="financial-close-menu__fc-masters-tooltip" v-if="mini" right content-class="tooltip-right" >
                <template #activator="{ on, attrs: tattrs }">
                  <span data-testid="financial-close-menu__fc-masters-icon-wrapper" v-bind="tattrs" v-on="on" class="d-flex align-center">
                    <span data-testid="financial-close-menu__fc-masters-mdi-icon" v-if="isMdi(item.icon)"><v-icon class="pr-2">{{ item.icon }}</v-icon></span>
                    <span data-testid="financial-close-menu__fc-masters-img-icon" class="pr-2 d-flex align-center" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
                    <span data-testid="financial-close-menu__fc-masters-default-icon" class="pr-2" v-else><v-icon>mdi-folder-outline</v-icon></span>
                  </span>
                </template>
                <span data-testid="financial-close-menu__fc-masters-tooltip-text" class="">{{ item.name }}</span>
              </v-tooltip>
              <template v-else>
                <span data-testid="financial-close-menu__fc-masters-mdi-icon" v-if="isMdi(item.icon)"><v-icon class="pr-2">{{ item.icon }}</v-icon></span>
                <span data-testid="financial-close-menu__fc-masters-img-icon" class="pr-2 d-flex align-center" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
                <span data-testid="financial-close-menu__fc-masters-default-icon" class="pr-2" v-else><v-icon>mdi-folder-outline</v-icon></span>
              </template>
              <v-list-item-content data-testid="financial-close-menu__fc-masters-content" class="pa-0 d-flex align-center justify-start">
                <v-list-item-title data-testid="financial-close-menu__fc-masters-title" class="hide-when-mini side-nav-text-color">{{ item.name }}</v-list-item-title>
              </v-list-item-content>
              <img src="/img/navicon/LeftArrow.svg" v-if="!mini" class="left-arrow-icon" alt="Left arrow for FC Masters"/>
            </v-list-item>
          </template>
          <v-card data-testid="financial-close-menu__fc-masters-card" class="fcmasters-menu-card">
            <h5 class="Menu-title mb-1 font-weight-medium" v-if="mini">{{ item.name }}</h5>
            <v-list data-testid="financial-close-menu__fc-masters-list" class="pa-0 d-flex flex-column gap-1">
              <v-list-item
                data-testid="financial-close-menu__fc-masters-item"
                v-for="sub in item.items"
                :key="sub.name + '-fcmasters-item'"
                :to="$nova.gotoLink({ path: sub.href, hash: sub.hash }, true)"
                link
                class="py-1"
                @click.stop="emitSelected(sub.name); fcMastersMenu=false"
              >
                <v-list-item-icon data-testid="financial-close-menu__fc-masters-item-icon" v-if="sub.icon" class="mr-2">
                  <template v-if="isMdi(sub.icon)"><v-icon data-testid="financial-close-menu__fc-masters-item-mdi-icon" class="side-nav-text-color">{{ sub.icon }}</v-icon></template>
                  <template v-else-if="isImg(sub.icon)"><img data-testid="financial-close-menu__fc-masters-item-img-icon" :src="sub.icon" class="nav-img-icon" /></template>
                  <template v-else><v-icon data-testid="financial-close-menu__fc-masters-item-default-icon" class="side-nav-text-color">mdi-file-outline</v-icon></template>
                </v-list-item-icon>
                <v-list-item-content data-testid="financial-close-menu__fc-masters-item-content" class="py-0">
                  <v-list-item-title data-testid="financial-close-menu__fc-masters-item-title" class="">{{ sub.name }}</v-list-item-title>
                </v-list-item-content>
                <shortcut-icon 
                  v-if="fbcShortcutEnabled"
                  :item="sub"
                  component="financialclose"
                  :loading="isShortcutLoading(sub)"
                  @add-shortcut="handleAddShortcut"
                />
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <!-- 2.5. Shortcuts fly-out -->
        <v-menu
          data-testid="financial-close-menu__shortcuts-menu"
          v-else-if="item.name === FC_MENU_NAMES.SHORTCUTS && hasShortcuts"
          :key="item.name + '-shortcuts'"
          v-model="shortcutsMenu"
          offset-x
          :nudge-right="0"
          :close-on-content-click="false"
          :open-delay="hoverOpenDelay"
          :close-delay="hoverCloseDelay"
          transition="fade-transition"
            :content-class="'shortcuts-menu ' + menuContentClass"
          open-on-hover
        >
          <template #activator="{ on, attrs }">
            <v-list-item
              data-testid="financial-close-menu__shortcuts-activator"
              v-bind="attrs"
              v-on="on"
              class="d-flex align-center justify-start all-width side-nav-text-color nav-standard-item"
              :class="(shortcutsMenu || isHeaderActive(item)) ? ' radius-small selected-menu-item' : ''"
            >
              <v-tooltip data-testid="financial-close-menu__shortcuts-tooltip" v-if="mini" right content-class="tooltip-right" >
                <template #activator="{ on, attrs: tattrs }">
                  <span data-testid="financial-close-menu__shortcuts-icon-wrapper" v-bind="tattrs" v-on="on" class="d-flex align-center">
                    <span data-testid="financial-close-menu__shortcuts-img-icon" class="pr-2 d-flex align-center"><img src="/img/navicon/Shortcuts.svg" class="nav-img-icon" /></span>
                  </span>
                </template>
                <span data-testid="financial-close-menu__shortcuts-tooltip-text" class="noTransform">{{ item.name }}</span>
              </v-tooltip>
              <template v-else>
                <span data-testid="financial-close-menu__shortcuts-img-icon" class="pr-2 d-flex align-center"><img src="/img/navicon/Shortcuts.svg" class="nav-img-icon" /></span>
              </template>
              <v-list-item-content data-testid="financial-close-menu__shortcuts-content" class="pa-0 d-flex align-center justify-start">
                <v-list-item-title data-testid="financial-close-menu__shortcuts-title" class="hide-when-mini side-nav-text-color">{{ item.name }}</v-list-item-title>
              </v-list-item-content>
              <img src="/img/navicon/LeftArrow.svg" v-if="!mini" class="left-arrow-icon" alt="Left arrow for Shortcuts"/>
            </v-list-item>
          </template>
          <v-card data-testid="financial-close-menu__shortcuts-card" class="fcmasters-menu-card">
            <h5 class="Menu-title mb-1 font-weight-medium" v-if="mini">{{ item.name }}</h5>
            <shortcuts-menu
              ref="shortcutsMenuComponent"
              :mini="mini"
              component="financialclose"
              @shortcut-click="handleShortcutClick"
              @shortcut-added="handleShortcutAdded"
              @shortcut-removed="handleShortcutRemoved"
            />
          </v-card>
        </v-menu>

        <!-- 3. Cycles with fly-out menu -->
        <template v-else-if="item.name === FC_MENU_NAMES.CYCLES" >
          <div
            data-testid="financial-close-menu__cycles-wrapper"
            :key="item.name + '-cycles-static'"
            :class="[
              'all-width side-nav-text-color cycles-wrapper d-flex flex-column gap-1',
              (item.items || []).length ? 'cycles-has-data' : ''
            ]"
          >
            <v-menu
              data-testid="financial-close-menu__cycles-menu"
              ref="cycleMenu"
              v-model="cyclesEndMenu"
              offset-x
              :nudge-right="0"
              :close-on-content-click="false"
              :open-delay="hoverOpenDelay"
              :close-delay="hoverCloseDelay"
              transition="fade-transition"
              :content-class="'cycles-end-menu ' + menuContentClass"
              open-on-hover
              @input="handleCyclesMenuOpen"
            >
              <template #activator="{ on, attrs }">
                <v-list-item
                  data-testid="financial-close-menu__cycles-root-item"
                  v-bind="attrs"
                  v-on="on"
                  class="d-flex align-center cycles-root-item nav-standard-item flex-fill"
                  :class="(cyclesEndMenu || isHeaderActive(item)) ? 'selected-menu-item' : ''"
                  @click.stop="handleCyclesRootClick"
                >
                  <v-tooltip data-testid="financial-close-menu__cycles-tooltip" v-if="mini" right content-class="tooltip-right" >
                    <template #activator="{ on: ton, attrs: tattrs }">
                      <span data-testid="financial-close-menu__cycles-icon-wrapper" class="d-flex align-center pr-2" v-bind="tattrs" v-on="ton">
                        <span data-testid="financial-close-menu__cycles-mdi-icon" v-if="isMdi(item.icon)"><v-icon>{{ item.icon }}</v-icon></span>
                        <span data-testid="financial-close-menu__cycles-img-icon" class="d-flex align-center" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
                        <span data-testid="financial-close-menu__cycles-default-icon" v-else><v-icon>mdi-folder-outline</v-icon></span>
                      </span>
                    </template>
                    <span data-testid="financial-close-menu__cycles-tooltip-text" class="">{{ item.name }}</span>
                  </v-tooltip>
                  <template v-else>
                    <span data-testid="financial-close-menu__cycles-mdi-icon" class="pr-2" v-if="isMdi(item.icon)"><v-icon>{{ item.icon }}</v-icon></span>
                    <span data-testid="financial-close-menu__cycles-img-icon" class="pr-2 d-flex align-center" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
                    <span data-testid="financial-close-menu__cycles-default-icon" class="pr-2" v-else><v-icon>mdi-folder-outline</v-icon></span>
                  </template>
                  <v-list-item-content data-testid="financial-close-menu__cycles-content" class="pa-0 d-flex align-center justfiy-start flex-grow-1">
                    <v-list-item-title data-testid="financial-close-menu__cycles-title" class="side-nav-text-color hide-when-mini noTransform">{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                  <img src="/img/navicon/LeftArrow.svg" v-if="!mini" class="left-arrow-icon" alt="Left arrow for FC Masters"/>
                </v-list-item>
              </template>
              <v-card data-testid="financial-close-menu__cycles-card" class="cycles-menu-card">
                <h5 class="Menu-title mb-1 font-weight-medium" v-if="mini">{{ item.name }}</h5>
                <cycle-switcher-menu
                  data-testid="financial-close-menu__cycles-actions"
                  v-model="cyclesEndMenu"
                  :mini="mini"
                  @action="handleCycleMenuClick"
                  @project-click="openCycleFromMenu"
                  ref="cycleSwitcherMenu"
                />
              </v-card>
            </v-menu>
            
            <div data-testid="financial-close-menu__cycles-scroll-area" class="scrollbar-none active-menu" style="max-height:50vh; overflow:scroll">
              <div
                data-testid="financial-close-menu__cycle-item"
                v-for="cycle in item.items"
                :key="cycle._id || cycle.name"
                class="pa-0 d-flex flex-column gap-1"
              >
                <template v-for="subItem in cycle.items">
                  <v-list-item
                    data-testid="financial-close-menu__cycle-sub-leaf"
                    v-if="!subItem.items"
                    :key="subItem.name + '-sub-leaf'"
                    link
                    :to="$nova.gotoLink({ path: subItem.href, hash: subItem.hash }, true)"
                    :class="selectedItem === subItem.name
                      ? ' selected-menu-item'
                      : 'border-left-grey-thin'"
                    @click="emitSelectedWithinCycle(subItem.name)"
                  >
                    <v-tooltip data-testid="financial-close-menu__cycle-sub-tooltip" v-if="mini" right content-class="tooltip-right" >
                      <template #activator="{ on, attrs }">
                        <v-list-item-icon data-testid="financial-close-menu__cycle-sub-icon" class="ma-auto" v-bind="attrs" v-on="on">
                          <template v-if="isMdi(subItem.icon)"><v-icon data-testid="financial-close-menu__cycle-sub-mdi-icon" class="side-nav-text-color">{{ subItem.icon }}</v-icon></template>
                          <template v-else-if="isImg(subItem.icon)"><img data-testid="financial-close-menu__cycle-sub-img-icon" :src="subItem.icon" class="nav-img-icon mr-2" alt="Automation" style="width: 22px; height: 22px;" /></template>
                          <template v-else><v-icon data-testid="financial-close-menu__cycle-sub-default-icon" class="side-nav-text-color">mdi-file-outline</v-icon></template>
                        </v-list-item-icon>
                      </template>
                      <span data-testid="financial-close-menu__cycle-sub-tooltip-text" class="">{{ subItem.name }}</span>
                    </v-tooltip>
                    <template v-else>
                      <v-list-item-icon data-testid="financial-close-menu__cycle-sub-icon" class="ma-auto">
                        <template v-if="isMdi(subItem.icon)"><v-icon data-testid="financial-close-menu__cycle-sub-mdi-icon" class="side-nav-text-color">{{ subItem.icon }}</v-icon></template>
                        <template v-else-if="isImg(subItem.icon)"><img data-testid="financial-close-menu__cycle-sub-img-icon" :src="subItem.icon" class="nav-img-icon mr-2" alt="Automation" style="width: 22px; height: 22px;" /></template>
                        <template v-else><v-icon data-testid="financial-close-menu__cycle-sub-default-icon" class="side-nav-text-color">mdi-file-outline</v-icon></template>
                      </v-list-item-icon>
                    </template>
                    <v-list-item-content data-testid="financial-close-menu__cycle-sub-content" class="pa-0">
                      <v-list-item-title
                        data-testid="financial-close-menu__cycle-sub-title"
                        class="side-nav-text-color hide-when-mini noTransform"
                      >{{ subItem.name }}</v-list-item-title>
                    </v-list-item-content>
                    <shortcut-icon 
                      v-if="!mini && fbcShortcutEnabled"
                      :item="subItem"
                      component="financialclose"
                      :loading="isShortcutLoading(subItem)"
                      @add-shortcut="handleAddShortcut"
                    />
                    
                  </v-list-item>
                  
                  <!-- Feature fly-outs and Cycle Settings fly-out -->
                  <v-menu
                    data-testid="financial-close-menu__feature-menu"
                    v-else-if="subItem.items && (subItem.name === botName || subItem.name === FC_MENU_NAMES.BOLT_ON_MODULES || subItem.name === FC_MENU_NAMES.CYCLE_SETTINGS)"
                    :key="subItem.name + '-feature-menu'"
                    :value="featureMenus[subItem.name]"
                    @input="$set(featureMenus, subItem.name, $event)"
                    offset-x
                    :nudge-right="0"
                    :open-delay="hoverOpenDelay"
                    :close-on-content-click="false"
                    :close-delay="hoverCloseDelay"
                    transition="fade-transition"
                    :content-class="'feature-menu ' + menuContentClass"
                    open-on-hover
                  >
                    <template #activator="{ on, attrs }">
                      <v-list-item
                        data-testid="financial-close-menu__feature-activator"
                        v-bind="attrs"
                        v-on="on"
                        class="border-left-grey-thin"
                        :class="selectedItem === subItem.name
                          ? ' selected-menu-item'
                          : 'border-left-grey-thin'"
                      >
                        <v-tooltip data-testid="financial-close-menu__feature-tooltip" v-if="mini" right content-class="tooltip-right" >
                          <template #activator="{ on: aon, attrs: aattrs }">
                            <v-list-item-icon data-testid="financial-close-menu__feature-icon" class="ma-auto" v-bind="aattrs" v-on="aon">
                              <template v-if="isMdi(subItem.icon)"><v-icon data-testid="financial-close-menu__feature-mdi-icon" class="side-nav-text-color">{{ subItem.icon }}</v-icon></template>
                              <template v-else-if="isImg(subItem.icon)"><img data-testid="financial-close-menu__feature-img-icon" :src="subItem.icon" class="nav-img-icon mr-2" alt="Automation" style="width: 22px; height: 22px;" /></template>
                              <template v-else><v-icon data-testid="financial-close-menu__feature-default-icon" class="side-nav-text-color">mdi-file-outline</v-icon></template>
                            </v-list-item-icon>
                          </template>
                          <span data-testid="financial-close-menu__feature-tooltip-text" class="">{{ subItem.name }}</span>
                        </v-tooltip>
                        <template v-else>
                          <v-list-item-icon data-testid="financial-close-menu__feature-icon" class="ma-auto">
                            <template v-if="isMdi(subItem.icon)"><v-icon data-testid="financial-close-menu__feature-mdi-icon" class="side-nav-text-color">{{ subItem.icon }}</v-icon></template>
                            <template v-else-if="isImg(subItem.icon)"><img data-testid="financial-close-menu__feature-img-icon" :src="subItem.icon" class="nav-img-icon mr-2" alt="Automation" style="width: 22px; height: 22px;" /></template>
                            <template v-else><v-icon data-testid="financial-close-menu__feature-default-icon" class="side-nav-text-color">mdi-file-outline</v-icon></template>
                          </v-list-item-icon>
                        </template>
                        <v-list-item-content data-testid="financial-close-menu__feature-content" class="pa-0">
                          <v-list-item-title data-testid="financial-close-menu__feature-title" class="side-nav-text-color hide-when-mini">{{ subItem.name }}</v-list-item-title>
                        </v-list-item-content>
                        <img src="/img/navicon/LeftArrow.svg" v-if="!mini" class="left-arrow-icon" alt="Left arrow for FC Masters"/>
                      </v-list-item>
                    </template>
                    <v-card data-testid="financial-close-menu__feature-card" class="fcmasters-menu-card">
                      <h5 class="Menu-title mb-1 font-weight-medium" v-if="mini">{{ subItem.name }}</h5>
                      <v-list data-testid="financial-close-menu__feature-list" class="pa-0 d-flex flex-column gap-1">
                        <template v-for="f in subItem.items">
                          <v-list-item
                            data-testid="financial-close-menu__feature-leaf"
                            v-if="!f.items"
                            :key="f.name + '-feature-leaf'"
                            link
                            :to="$nova.gotoLink({ path: f.href, hash: f.hash }, true)"
                            class="py-1 feature-leaf"
                            :class="{ 'is-selected': selectedItem === f.name }"
                            @click.stop="emitSelected(f.name); $set(featureMenus, subItem.name, false)"
                          >
                            <v-list-item-icon data-testid="financial-close-menu__feature-leaf-icon" v-if="f.icon" class="mr-2">
                              <template v-if="isMdi(f.icon)"><v-icon data-testid="financial-close-menu__feature-leaf-mdi-icon" class="side-nav-text-color">{{ f.icon }}</v-icon></template>
                              <template v-else-if="isImg(f.icon)"><img data-testid="financial-close-menu__feature-leaf-img-icon" :src="f.icon" class="nav-img-icon" /></template>
                              <template v-else><v-icon data-testid="financial-close-menu__feature-leaf-default-icon" class="side-nav-text-color">mdi-file-outline</v-icon></template>
                            </v-list-item-icon>
                            <v-list-item-content data-testid="financial-close-menu__feature-leaf-content" class="py-0">
                              <v-list-item-title data-testid="financial-close-menu__feature-leaf-title" class="noTransform">{{ f.name }}</v-list-item-title>
                            </v-list-item-content>
                            <shortcut-icon 
                              v-if="fbcShortcutEnabled"
                              :item="f"
                              component="financialclose"
                              :loading="isShortcutLoading(f)"
                              @add-shortcut="handleAddShortcut"
                            />
                          </v-list-item>
                          <div data-testid="financial-close-menu__feature-group" v-else :key="f.name + '-feature-group'" class="feature-sub-group">
                            <div data-testid="financial-close-menu__feature-group-header" class="feature-sub-group-header">{{ f.name }}</div>
                            <v-list-item
                              data-testid="financial-close-menu__feature-nested-leaf"
                              v-for="g in f.items"
                              :key="g.name + '-feature-nested-leaf'"
                              link
                              :to="$nova.gotoLink({ path: g.href, hash: g.hash }, true)"
                              class="py-1 feature-leaf ml-2"
                              :class="{ 'is-selected': selectedItem === g.name }"
                              @click.stop="emitSelected(g.name); $set(featureMenus, subItem.name, false)"
                            >
                              <v-list-item-icon data-testid="financial-close-menu__feature-nested-icon" v-if="g.icon" class="mr-2">
                                <template v-if="isMdi(g.icon)"><v-icon data-testid="financial-close-menu__feature-nested-mdi-icon" small class="side-nav-text-color">{{ g.icon }}</v-icon></template>
                                <template v-else-if="isImg(g.icon)"><img data-testid="financial-close-menu__feature-nested-img-icon" :src="g.icon" class="nav-img-icon" /></template>
                                <template v-else><v-icon data-testid="financial-close-menu__feature-nested-default-icon" small class="side-nav-text-color">mdi-file-outline</v-icon></template>
                              </v-list-item-icon>
                              <v-list-item-content data-testid="financial-close-menu__feature-nested-content" class="py-0">
                                <v-list-item-title data-testid="financial-close-menu__feature-nested-title" class="">{{ g.name }}</v-list-item-title>
                              </v-list-item-content>
                              <shortcut-icon 
                                v-if="fbcShortcutEnabled"
                                :item="g"
                                component="financialclose"
                                :loading="isShortcutLoading(g)"
                                @add-shortcut="handleAddShortcut"
                              />
                            </v-list-item>
                          </div>
                        </template>
                      </v-list>
                    </v-card>
                  </v-menu>
                  <!-- Other nested groups inline -->
                  <v-list-group data-testid="financial-close-menu__nested-group" v-else sub-group no-action :key="subItem.name + '-sub-group'">
                    <template #activator>
                      <v-list-item-content data-testid="financial-close-menu__nested-activator-content" class="pa-0" :class="isHeaderActive(subItem) ? ' font-weight-bold' : ''">
                        <v-list-item-title
                          data-testid="financial-close-menu__nested-activator-title"
                          class="side-nav-text-color hide-when-mini"
                          @click.stop="emitSelected(subItem.name)"
                        >{{ subItem.name }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-for="nestedItem in subItem.items">
                      <v-list-item
                        data-testid="financial-close-menu__nested-leaf"
                        v-if="!nestedItem.items"
                        :key="nestedItem.name + '-nested-leaf'"
                        link
                        class="border-left-grey-thin pa-0"
                        :to="$nova.gotoLink({ path: nestedItem.href, hash: nestedItem.hash }, true)"
                        :class="selectedItem === nestedItem.name
                          ? 'selected-menu-item'
                          : 'border-left-grey-thin'"
                      >
                        <v-list-item-content data-testid="financial-close-menu__nested-leaf-content" class="pa-0">
                          <v-list-item-title
                            data-testid="financial-close-menu__nested-leaf-title"
                            class="side-nav-text-color hide-when-mini"
                            @click.stop="emitSelected(nestedItem.name)"
                          >{{ nestedItem.name }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-group data-testid="financial-close-menu__double-nested-group" v-else sub-group no-action class="ml-3" :key="nestedItem.name + '-nested-group'">
                        <template #activator>
                          <v-list-item-content data-testid="financial-close-menu__double-nested-activator-content" class="pa-0" :class="isHeaderActive(nestedItem) ? ' font-weight-bold' : ''">
                            <v-list-item-title
                              data-testid="financial-close-menu__double-nested-activator-title"
                              class="side-nav-text-color hide-when-mini"
                              @click.stop="emitSelected(nestedItem.name)"
                            >{{ nestedItem.name }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <v-list-item
                          data-testid="financial-close-menu__double-nested-leaf"
                          v-for="doubleNestedItem in nestedItem.items"
                          :key="doubleNestedItem.name + '-double-leaf'"
                          link
                          class="border-left-grey-thin pa-0"
                          :to="$nova.gotoLink({ path: doubleNestedItem.href, hash: doubleNestedItem.hash }, true)"
                          :class="selectedItem === doubleNestedItem.name
                            ? 'selected-menu-item'
                            : 'border-left-grey-thin'"
                        >
                          <v-list-item-content data-testid="financial-close-menu__double-nested-leaf-content" class="pa-0">
                            <v-list-item-title
                              data-testid="financial-close-menu__double-nested-leaf-title"
                              class="side-nav-text-color hide-when-mini"
                              @click.stop="emitSelected(doubleNestedItem.name)"
                            >{{ doubleNestedItem.name }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-group>
                    </template>
                  </v-list-group>
                </template>
              </div>
            </div>
          </div>
        </template>

        <!-- Other grouped items -->
        <v-list-group
          data-testid="financial-close-menu__other-group"
          v-else
          :key="item.name + '-group'"
          no-action
          :value="false"
          class="all-width side-nav-text-color"
        >
          <template #activator>
            <v-list-item data-testid="financial-close-menu__other-group-activator" class="pa-0 position-relative d-flex align-center nav-standard-item" :class="isHeaderActive(item) ? ' radius-small selected-menu-item' : ''">
              <v-tooltip data-testid="financial-close-menu__other-group-tooltip" v-if="mini" right content-class="tooltip-right" >
                <template #activator="{ on, attrs }">
                  <span data-testid="financial-close-menu__other-group-icon-wrapper" v-bind="attrs" v-on="on" class="d-flex align-center">
                    <span data-testid="financial-close-menu__other-group-mdi-icon" class="pr-2" v-if="isMdi(item.icon)"><v-icon>{{ item.icon }}</v-icon></span>
                    <span data-testid="financial-close-menu__other-group-img-icon" class="pr-2" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
                    <span data-testid="financial-close-menu__other-group-default-icon" class="pr-2" v-else><v-icon>mdi-folder-outline</v-icon></span>
                  </span>
                </template>
                <span data-testid="financial-close-menu__other-group-tooltip-text"  class="">{{ item.name }}</span>
              </v-tooltip>
              <template v-else>
                <span data-testid="financial-close-menu__other-group-mdi-icon" class="pr-2" v-if="isMdi(item.icon)"><v-icon>{{ item.icon }}</v-icon></span>
                <span data-testid="financial-close-menu__other-group-img-icon" class="pr-2" v-else-if="isImg(item.icon)"><img :src="item.icon" class="nav-img-icon" /></span>
                <span data-testid="financial-close-menu__other-group-default-icon" class="pr-2" v-else><v-icon>mdi-folder-outline</v-icon></span>
              </template>
              <v-list-item-content data-testid="financial-close-menu__other-group-content" class="pa-0 d-flex align-center justfiy-start flex-grow-1">
                <v-list-item-title
                  data-testid="financial-close-menu__other-group-title"
                  class="side-nav-text-color hide-when-mini"
                  @click.stop="emitSelected(item.name)"
                >{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item
            data-testid="financial-close-menu__other-group-item"
            v-for="subItem in item.items"
            :key="subItem.name + '-other'"
            :to="$nova.gotoLink({ path: subItem.href, hash: subItem.hash }, true)"
            link
            class="list-padding"
            :class="selectedItem === subItem.name ? ' radius-small selected-menu-item' : ''"
          >
            <v-list-item-icon data-testid="financial-close-menu__other-group-item-icon" class="ma-0">
              <template v-if="isMdi(subItem.icon)"><v-icon data-testid="financial-close-menu__other-group-item-mdi-icon" class="side-nav-text-color">{{ subItem.icon }}</v-icon></template>
              <template v-else-if="isImg(subItem.icon)"><img data-testid="financial-close-menu__other-group-item-img-icon" :src="subItem.icon" class="nav-img-icon" /></template>
              <template v-else><v-icon data-testid="financial-close-menu__other-group-item-default-icon" class="side-nav-text-color">mdi-file-outline</v-icon></template>
            </v-list-item-icon>
            <v-list-item-content data-testid="financial-close-menu__other-group-item-content" class="pa-0">
              <v-list-item-title
                data-testid="financial-close-menu__other-group-item-title"
                class="side-nav-text-color hide-when-mini noTransform"
                @click.stop="emitSelected(subItem.name); emitOpenMenu(false)"
              >{{ subItem.edit === true ? $store.state.LocationHeader || FC_MENU_NAMES.LOCATION : subItem.name }}</v-list-item-title>
            </v-list-item-content>
            <shortcut-icon 
              v-if="!mini && fbcShortcutEnabled"
              :item="subItem"
              component="financialclose"
              :loading="isShortcutLoading(subItem)"
              @add-shortcut="handleAddShortcut"
            />
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>

    <!-- Subscriptions fly-out -->
    <v-list data-testid="financial-close-menu__bottom-utilities" class="all-width pa-0">
      <!-- Chatbot menu item -->
      <chatbot-menu-item
        v-if="chatbotEnabled"
        :mini="mini"
        :use-drawer="true"
        test-id-prefix="financial-close-menu"
        extra-classes="mt-2 all-width justify-start menu-trigger-item"
        :active="selectedItem === 'chatbot'"
        label-class="hide-when-mini pl-2 side-nav-text-color"
        label-tag="p"
        @click="toggleChatbot"
      />

      <support-menu-item
        v-if="showManuals"
        :mini="mini"
        :use-widget="true"
        label="Manuals"
        icon-src="/img/icons/ManualsIcon.svg"
        icon-alt="Product manuals"
        aria-label="Product manuals"
        test-id-prefix="financial-close-menu-manuals"
        extra-classes="mt-2 all-width justify-start menu-trigger-item"
        :active="isManualsActive"
        active-class="radius-small selected-menu-item"
        label-class="hide-when-mini pl-2 side-nav-text-color"
        label-tag="p"
        @click="openManuals"
      />

      <!-- Help & Support trigger -->
      <support-menu-item
        v-if="fdSupportWidget"
        :mini="mini"
        :use-widget="true"
        test-id-prefix="financial-close-menu"
        extra-classes="mt-2 all-width justify-start menu-trigger-item support-trigger"
        :active="selectedItem === 'support'"
        label-class="hide-when-mini pl-2 side-nav-text-color"
        @click="openFDSupport"
        label-tag="p"
      />
      <support-menu-item
        v-else
        :mini="mini"
        :use-widget="false"
        test-id-prefix="financial-close-menu"
        extra-classes="mt-2 all-width justify-start menu-trigger-item support-trigger"
        :active="selectedItem === 'support'"
        :support-route="FC_ROUTES.SUPPORT"
        label-class="hide-when-mini pl-2 side-nav-text-color"
        label-tag="p"
      />

      <!-- Profile fly-out -->
      <profile-menu-flyout
        v-model="profileMenu"
        :mini="mini"
        :hover-open-delay="hoverOpenDelay"
        :hover-close-delay="hoverCloseDelay"
        :content-class="menuContentClass"
        :close-on-content-click="false"
        test-id-prefix="financial-close-menu"
        @edit-profile="$emit('edit-profile')"
      />

      <!-- Subscription (Apps) menu -->
      <subscriptions-menu-flyout
        v-model="subscriptionsMenu"
        :mini="mini"
        :hover-open-delay="hoverOpenDelay"
        :hover-close-delay="hoverCloseDelay"
        :content-class="menuContentClass"
        :close-on-content-click="false"
        activator-active-class="radius-small"
        :applist="applist"
        :is-app-active="isAppActive"
        selected-item-class="radius-small selected-menu-item"
        :show-shortcut-icon="fbcShortcutEnabled"
        :shortcut-loading-fn="isShortcutLoading"
        shortcut-icon-class="ml-2 cursor-pointer shortcut-icon"
        shortcut-icon-alt="Add Shortcut"
        test-id-prefix="financial-close-menu"
        @app-click="handleAppClick"
        @add-shortcut="handleSubscriptionsShortcut"
      />
    </v-list>
  </v-list>
</template>

<script>
import constants from '../../plugins/constants.js';
import { MASTER_PREFIX, FC_MENU_NAMES, FC_ROUTES } from '../../modules/financialclose/utils/constants.js';
import ProfileMenuFlyout from '../navigation/ProfileMenuFlyout.vue';
import SubscriptionsMenuFlyout from '../navigation/SubscriptionsMenuFlyout.vue';
import SupportMenuItem from '../navigation/SupportMenuItem.vue';
import ChatbotMenuItem from '../navigation/ChatbotMenuItem.vue';

export default {
  name: 'FinancialCloseMenu',
  components: {
    CycleSwitcherMenu: () => import('./CycleSwitcherMenu.vue'),
    ShortcutsMenu: () => import('./ShortcutsMenu.vue'),
    ShortcutIcon: () => import('./ShortcutIcon.vue'),
    ProfileMenuFlyout,
    SubscriptionsMenuFlyout,
    SupportMenuItem,
    ChatbotMenuItem
  },
  props: {
    mini: { type: Boolean, default: false },
    selectedItem: { type: String, default: null },
    openMenu: { type: Boolean, default: false },
    applist: { type: Array, default: () => [] },
    fdSupportWidget: { type: Boolean, default: false },
    chatbotEnabled: { type: Boolean, default: false },
    showManuals: { type: Boolean, default: false },
  },
  emits: ['update:selectedItem', 'update:openMenu', 'logout', 'edit-profile', 'manuals-click'],
  data() {
    return {
      FC_MENU_NAMES,
      FC_ROUTES,
      cycleOpen: {},
      cyclesEndMenu: false,
      cyclesBackup: null,
      fcMastersMenu: false,
      shortcutsMenu: false,
      featureMenus: {},
      botName: constants.BOT_NAME,
      profileMenu: false,
      subscriptionsMenu: false,
      selectedAppKey: null,
      shortcutPendingName: null
    };
  },
  computed: {
    isManualsActive() {
      return this.$constants.isManualsPath(this.$route.path || '');
    },
    hoverOpenDelay() {
      const config = this.$constants.STYLES.SIDE_NAV;
      return this.mini ? config.COLLAPSED.OPEN_DELAY : config.EXPANDED.OPEN_DELAY;
    },
    hoverCloseDelay() {
      const config = this.$constants.STYLES.SIDE_NAV;
      return this.mini ? config.COLLAPSED.CLOSE_DELAY : config.EXPANDED.CLOSE_DELAY;
    },
    menuContentClass() {
      return this.mini ? 'nav-menu-collapsed' : 'nav-menu-expanded';
    },
    componentKey() {
      return constants.PRODUCT_KEYS.FINANCIAL_CLOSE;
    },
    menu() {
      // Read from the financialclose module store directly
      // This ensures we get updates from addItemToCycleList without waiting for route change
      return this.$store.state.m_financialclose?.menu || this.$store.state.menu || [];
    },
    displayMenu() {
      const baseMenu = (this.menu || []).filter(item => {
        if (item?.name === FC_MENU_NAMES.MASTERS && !this.canAccessFinancialCloseMasters) {
          return false;
        }

        if (item?.name === FC_MENU_NAMES.SHORTCUTS && !this.hasShortcuts) {
          return false;
        }

        return true;
      });

      return baseMenu;
    },
    hasShortcuts() {
      return this.fbcShortcutEnabled && this.$store.getters['shortcuts/hasShortcuts'](this.componentKey);
    },
    fbcShortcutEnabled() {
      return this.$store.state.pinCount !== -1;
    },
    activeClientDetails() {
      return this.$store.state.clientDetails || {};
    },
    canAccessFinancialCloseMasters() {
      const isFinancialCloseAdmin = this.activeClientDetails?.isFinancialCloseAdmin;
      // Default to false when permission flag is missing/undefined to avoid accidental Masters access
      return typeof isFinancialCloseAdmin === 'boolean' ? isFinancialCloseAdmin : false;
    }
  },
  mounted() {
    if (this.fbcShortcutEnabled) {
      this.$store.dispatch('shortcuts/fetchShortcuts', { component: this.componentKey });
    }
    // On mount (including page refresh), check if we need to populate cycle menu from route
    this.initCycleFromRoute();
  },
  methods: {
    /**
     * Initialize cycle menu from current route on page load/refresh
     * Detects if we're on a cycle-specific page and populates the menu accordingly
     */
    async initCycleFromRoute() {
      const routePath = this.$route?.path || '';
      
      // Only process cycle routes
      if (!routePath.includes(constants.PRODUCT_KEYS.FINANCIAL_CLOSE)) return;
      
      // Check if CycleList is already populated
      const cycleMenuItem = this.menu.find(m => m.name === FC_MENU_NAMES.CYCLES);
      if (cycleMenuItem?.items?.length > 0) return;
      
      try {
        await this.$store.dispatch('fetchAndSetCycleFromRoute', { routePath });
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      } catch (err) {
        console.error('[FinancialCloseMenu]: initCycleFromRoute error', err);
      }
    },
    handleCyclesMenuOpen() {
      if (this.cyclesEndMenu) {
        this.$nextTick(() => {
          this.$refs.cycleSwitcherMenu?.fetchProjects?.();
        });
      }
    },
    
    toggleFcMastersMenu(name) {
      this.fcMastersMenu = !this.fcMastersMenu;
      this.emitSelected(this.fcMastersMenu ? name : null);
    },
    
    onFcMastersMenuInput(val) {
      this.fcMastersMenu = val;
      if (!val) this.emitSelected(null);
    },
    
    onShortcutsMenuInput(val) {
      this.shortcutsMenu = val;
      if (!val) this.emitSelected(null);
    },
    
    async handleAddShortcut(shortcutData) {
      if (!this.fbcShortcutEnabled) return false;

      const resolveRef = () => {
        const ref = this.$refs.shortcutsMenuComponent;
        return Array.isArray(ref) ? ref[0] : ref;
      };

      const shortcutsMenuInstance = resolveRef();
      
      // Prepend master prefix to shortcut name if adding from Masters menu
      let modifiedShortcutData = JSON.parse(JSON.stringify(shortcutData));
      if (this.fcMastersMenu && shortcutData?.name) {
        modifiedShortcutData.name = `${MASTER_PREFIX} ${shortcutData.name}`;
      }
      
      const pendingName = modifiedShortcutData?.name || null;
      if (pendingName) {
        if (this.shortcutPendingName === pendingName) {
          return false;
        }
        this.shortcutPendingName = pendingName;
      }

      let result = false;

      // Try to use the ShortcutsMenu component if available
      if (shortcutsMenuInstance && typeof shortcutsMenuInstance.addShortcut === 'function') {
        try {
          result = await shortcutsMenuInstance.addShortcut(modifiedShortcutData);
        } finally {
          if (pendingName && this.shortcutPendingName === pendingName) {
            this.shortcutPendingName = null;
          }
        }
        return result;
      }
      
      // Fallback: Add shortcut directly via API if component ref is not available
      try {
        const storeResult = await this.$store.dispatch('shortcuts/addShortcut', {
          component: this.componentKey,
          shortcut: {
            name: modifiedShortcutData.name,
            url: modifiedShortcutData.url,
            meta: modifiedShortcutData.meta || {}
          }
        });

        const message = storeResult?.message || 'Failed to add shortcut.';

        if (storeResult?.type === 'success') {
          this.$store?.commit?.('sbSuccess', message);
          this.$toast?.success?.(message);
          result = true;
        } else if (storeResult?.type === 'warning') {
          this.$store?.commit?.('sbWarning', message);
          this.$toast?.warning?.(message);
        } else if (storeResult?.type === 'info') {
          this.$store?.commit?.('sbInfo', message);
          this.$toast?.info?.(message);
        } else {
          this.$store?.commit?.('sbError', message);
          this.$toast?.error?.(message);
        }
      } catch (error) {
        console.error('Failed to add shortcut:', error);
        const message = error.response?.data?.message || 'Failed to add shortcut.';
        this.$store?.commit?.('sbError', message);
        this.$toast?.error?.(message);
        result = false;
      }
      finally {
        if (pendingName && this.shortcutPendingName === pendingName) {
          this.shortcutPendingName = null;
        }
      }
      return result;
    },
    
    handleShortcutClick(shortcut) {
      // Close the shortcuts menu when a shortcut is clicked
      this.shortcutsMenu = false;
      this.emitSelected(shortcut.name);
    },
    
    async handleShortcutAdded() {
      this.shortcutsMenu = false;
    },
    
    async handleShortcutRemoved() {
      if (!this.hasShortcuts) {
        this.shortcutsMenu = false;
      }
    },

    isShortcutLoading(item) {
      const name = item?.name || item?.title || item?.displayname || null;
      if (!name) return false;
      return this.shortcutPendingName === name;
    },
    
    isMdi(val) {
      return typeof val === 'string' && /^mdi[\s-]/.test(val);
    },
    
    isImg(val) {
      return typeof val === 'string' && /\.(svg|png|jpe?g|webp|gif)$/i.test(val);
    },
    
    isHeaderActive(item) {
      if (!item) return false;
      if (this.selectedItem === item.name) return true;
      if (!item.items) return false;
      
      const stack = [...item.items];
      while (stack.length) {
        const node = stack.pop();
        if (!node) continue;
        if (this.selectedItem === node.name) return true;
        if (node.items?.length) stack.push(...node.items);
      }
      return false;
    },
    
    emitSelected(name) {
      if (name) {
        this.$root.closeFloatingComponents?.(name);
      }
      this.$emit('update:selectedItem', name);
    },

    emitSelectedWithinCycle(name) {
      if (name) {
        this.$root.closeFloatingComponents?.(name);
      }
    },
    
    emitOpenMenu(flag) {
      this.$emit('update:openMenu', flag);
    },
    
    handleTopLevelClick(item) {
      this.emitSelected(item.name);
      if (item.name !== FC_MENU_NAMES.CYCLES) this.emitOpenMenu(false);
    },
    
    handleCyclesRootClick() {
      this.emitSelected(FC_MENU_NAMES.CYCLES);
      this.cyclesEndMenu = true;
    },
    
    isCycleActive(cycleId) {
      return this.$route.path.includes(cycleId);
    },
    
    openManuals() {
      this.$emit('manuals-click');
    },
    openFDSupport() {
      this.$root.closeFloatingComponents?.();
      this.$emit('update:selectedItem', 'support');
      this.$root.openFDSupport?.();
    },
    
    toggleChatbot() {
      this.$emit('update:selectedItem', 'chatbot');
      this.$root.toggleChatbot?.();
    },
    
    handleCycleMenuClick(item) {
      this.$root.closeFloatingComponents?.();
      this.$emit('cycles-menu-action', item.action);
      this.cyclesEndMenu = false;
    },
    openCycleFromMenu(project) {
      if (!project?._id) return;
      
      if (!this.openMenu) this.emitOpenMenu(true);
      
      const cyclesMenuItem = this.menu.find(i => i.name === FC_MENU_NAMES.CYCLES);
      if (!cyclesMenuItem) return;
      
      // Backup cycles on first use
      if (this.cyclesBackup === null) {
        this.cyclesBackup = (cyclesMenuItem.items || []).slice();
      }
      
      // Find cycle
      let cycle = cyclesMenuItem.items?.find(c => c._id === project._id);
      if (!cycle && this.cyclesBackup) {
        cycle = this.cyclesBackup.find(c => c._id === project._id);
      }
      
      // Try to add to store if not found
      if (!cycle) {
        try {
          this.$store.commit('addItemToCycleList', project);
          cycle = cyclesMenuItem.items?.find(c => c._id === project._id);
        } catch (e) {
          // Mutation may not exist in some deployments
        }
      }
      
      // Update cycle list
      this.$set(cyclesMenuItem, 'items', [cycle]);
      this.cycleOpen = {};
      const key = cycle._id || cycle.name;
      this.$set(this.cycleOpen, key, true);
      
      // Navigate to cycle, keeping current page context
      const { params, path, name, query } = this.$route;
      const projectId = project._id;
      
      const navigate = (target) => {
        this.$router.replace(target).catch(() => {});
      };
      
      if (params.id) {
        // Replace ID param in path
        const newPath = path.replace(/\/[^/]+$/, `/${projectId}`);
        navigate({ path: newPath, query });
      } else if (params.projectId) {
        // Replace projectId param
        navigate({
          name,
          params: { ...params, projectId },
          query
        });
      } else {
        // Fallback: navigate to Tasklist page for this cycle
        const tasklistChild = cycle.items?.find(i => i.name === FC_MENU_NAMES.TASKLIST) || cycle.items?.[0];
        if (tasklistChild?.href) {
          const target = this.$nova?.gotoLink({ path: tasklistChild.href }, true) || tasklistChild.href;
          this.$router.push(target).catch(() => {});
        }
      }
      
      this.cyclesEndMenu = false;
    },
    
    isAppActive(app) {
      if (!app) return false;
      if (this.selectedAppKey === app.name) return true;
      
      try {
        const link = app.link?.replace(/\/$/, '');
        return link && this.$route.path.startsWith(link);
      } catch (e) {
        return false;
      }
    },
    
    handleAppClick(app) {
      if (!app) return;
      this.$root.closeFloatingComponents?.();
      this.selectedAppKey = app.name;
      try {
        this.$nova.gotoLink({ path: app.link });
      } catch (e) {
        // Navigation failure is non-fatal
      }
      this.subscriptionsMenu = false;
    },

    handleSubscriptionsShortcut(app) {
      if (!app) return;
      const name = app.displayname || app.name;
      if (!name) return;
      this.handleAddShortcut({
        name,
        url: app.link,
        meta: app.meta || {}
      });
    }
  },
  watch: {
    canAccessFinancialCloseMasters(value) {
      if (!value) {
        this.fcMastersMenu = false;
      }
    },
    hasShortcuts(value) {
      if (!value) {
        this.shortcutsMenu = false;
      }
    },
    mini() {
      // Refresh menu positioning after mini state change
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.cycleMenu?.updateDimensions?.();
        }, 350);
      });
      
      // Helper to toggle menu states
      const toggleMenu = (menuKey) => {
        if (this[menuKey]) {
          this[menuKey] = false;
          this.$nextTick(() => {
            this[menuKey] = true;
          });
        }
      };
      
      // Toggle all menus for correct positioning
      toggleMenu('cyclesEndMenu');
      toggleMenu('fcMastersMenu');
      toggleMenu('profileMenu');
      toggleMenu('subscriptionsMenu');
      
      // Handle feature menus
      Object.keys(this.featureMenus).forEach(key => {
        if (this.featureMenus[key]) {
          this.$set(this.featureMenus, key, false);
          this.$nextTick(() => {
            this.$set(this.featureMenus, key, true);
          });
        }
      });
    },
    
    '$route.path': {
      immediate: true,
      handler(path) {
        // Close cycles menu on route change
        if (this.cyclesEndMenu) {
          this.cyclesEndMenu = false;
        }
        
        // Only process financial close routes
        if (!path.includes(constants.PRODUCT_KEYS.FINANCIAL_CLOSE)) return;
        
        // Handle cycles
        const cyclesItem = this.menu.find(item => item.name === FC_MENU_NAMES.CYCLES);
        if (cyclesItem) {
          const cycles = cyclesItem.items || [];
          
          // If cycles is empty, try to populate from route
          if (cycles.length === 0) {
            this.initCycleFromRoute();
            return;
          }
          
          const matchingCycle = cycles.some(c => path.includes(c._id));
          
          if (matchingCycle && !this.openMenu) {
            this.emitOpenMenu(true);
          }
          
          cycles.forEach(cycle => {
            if (path.includes(cycle._id)) {
              const key = cycle._id || cycle.name;
              this.$set(this.cycleOpen, key, true);
            }
          });
          return;
        }
        
        // Handle app selection
        if (this.applist?.length) {
          const found = this.applist.find(app => {
            const link = app.link?.replace(/\/$/, '');
            return link && path.startsWith(link);
          });
          
          if (found) {
            this.selectedAppKey = found.name;
          }
        }
      }
    }
  }
};
</script>

<style scoped>
/* Component-specific only (none – using global shared styles) */
.custom-cycles-menu-width {
  min-width: 220px !important;
}
.cursor-pointer {
  cursor: pointer;
}
/* Unscoped styles for v-menu components */
.cycles-end-menu , .cycles-menu-card, .shortcuts-menu {
  min-width: 200px !important;
}
.v-list-item:hover .shortcut-icon{
  opacity: 1;
}
.shortcut-icon {
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease;
  margin-left: 8px;
}

.shortcut-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

.shortcut-icon--active {
  opacity: 1;
  filter: brightness(1.2);
}

</style>
